import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PillarPageJsonLd from './components/PillarPageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import TableOfContents from './components/TableOfContents';
import ArticleSection from './components/ArticleSection';
import StatisticsSection from './components/StatisticsSection';
import ComparisonTable from './components/ComparisonTable';
import FormatsSection from './components/FormatsSection';
import CommonTasksSection from './components/CommonTasksSection';
import ProcessSection from './components/ProcessSection';
import ExternalTrainerSection from './components/ExternalTrainerSection';
import MethodsSection from './components/MethodsSection';
import CTASection from './components/CTASection';
import AuthorSection from './components/AuthorSection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const corporateNavLinks = [
  { label: 'Содержание', target: 'table-of-contents' },
  { label: 'Что это', target: 'what-is' },
  { label: 'Виды', target: 'types' },
  { label: 'Методы', target: 'methods' },
  { label: 'FAQ', target: 'faq' },
];

export default function PillarPage() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      
      <SeoTitle title="Корпоративное обучение сотрудников | Business Training" />
      <PillarPageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={corporateNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <TableOfContents scrollTo={scrollTo} />
        <ArticleSection scrollTo={scrollTo} />
        <StatisticsSection />
        <ComparisonTable />
        <FormatsSection />
        <CommonTasksSection />
        <ProcessSection scrollTo={scrollTo} />
        <ExternalTrainerSection />
        <MethodsSection scrollTo={scrollTo} />
        <CTASection />
        <AuthorSection />
        <LeadMagnetBlock variant="compact" />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}